.searchPopup {
  background-color: var(--primitives-colors-neutral-980);
  width: 100%;
  border-radius: 24px;
  padding: 16px 0;
  position: absolute;
  max-width: 500px;
  top: 55px;
  border: 1px solid var(--primitives-colors-neutral-0);
  z-index: 2;

  .phone &,
  .tablet & {
    background-color: var(--primitives-colors-neutral-980);
    position: fixed;
    max-height: inherit;
    padding: 0;
    max-width: 100%;
    height: 100%;
    left: 0;
    top: 104px;
    border-radius: 0;
    border: none;
  }

  &Overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 68px;
    left: 0;
    bottom: 0;
    background: linear-gradient(179.46deg, rgb(0, 0, 0, 0.25) 45.72%, rgb(255, 0, 4, 0.25) 125.24%);
    backdrop-filter: blur(8px);

    .phone &,
    .tablet & {
      display: none;
    }
  }
}

